import script from "./BindSkuItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./BindSkuItem.vue?vue&type=script&lang=ts&setup=true"

import "./BindSkuItem.vue?vue&type=style&index=0&id=b74ab632&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b74ab632"]])

export default __exports__